// Someday we can maybe replace this with Intl.DurationFormat
// https://github.com/tc39/proposal-intl-duration-format

export const POLL_EXPIRY_OPTIONS = [
  {
    value: 300,
    label: "5 minutes"
  },
  {
    value: 1800,
    label: "30 minutes"
  },
  {
    value: 3600,
    label: "1 hour"
  },
  {
    value: 21600,
    label: "6 hours"
  },
  {
    value: 86400,
    label: "1 day"
  },
  {
    value: 259200,
    label: "3 days"
  },
  {
    value: 604800,
    label: "7 days"
  }
]

export const POLL_EXPIRY_DEFAULT = 86400
